import { Component, Input, Optional, Inject, HostListener, Output, EventEmitter } from '@angular/core';
import { PershingTranslationService, IAuthorizationService } from '@pershing/pershing-core';
import { NxiIconService } from '../services/icon.service';
import { Location } from '@angular/common';
import { NavigationConstants } from '../utils/navigation.constants';

@Component({
    selector: 'nxi-icons',
    templateUrl: 'icons.component.html'
})
export class IconsComponent {
    private hasMessage: boolean;
    private appSettings: any;
    showGoPaperlessFillerSpan: boolean = false;
    isLoggedIn: boolean = false;
    @Input() isPreLogin: boolean = false;
    isDisclosurePage: boolean;
    noMessages: boolean;
    private goPaperlessFillerSpanIBDList: string[] = ['XGW'];
    marketSnapshotEntitlements: string[] = ['DELAYED_EQUITY_QUOTES', 'REAL_TIME_EQUITY_QUOTES', 'DELAYED_OPTION_QUOTES',
        'REAL_TIME_OPTION_QUOTES', 'MUTUAL_FUND_QUOTES', 'RT_QUOTES_TRADING', 'STREAMING_QUOTES'];
    isMarketSnapshotsEnabled: boolean = false;
    isEdelEnabled: boolean = false;
    isCBOL: boolean = false;
    isSSOLogoutHide: boolean = false;
    public msgLists: Array<any>; /* To store all the Messages */
    @Output() redirect: EventEmitter<any> = new EventEmitter();
    hideMessageIcon: boolean = false;
    isModernTheme: boolean = false;
    isTradeEntitled: boolean;
    isTransferEntitled: boolean;
    isPayBillsEntitled: boolean;
    tradingEntitlements: string[] = ['STOCK_TRADING', 'OPTIONS_TRADING', 'MUTUAL_FUND_TRADING', 'TRADING_529_FUND', 'XTND_HOURS'];

    // Once user expands all messages message-center publishes this and asterisk icon should be hiden.
    @HostListener('document:portal.allMsgRead', ['$event']) onAllMsgRead(e) {
        if (!!e.detail && !!e.detail.allMsgRead && e.detail.allMsgRead) {
            this.noMessages = true;
        }
    }

    constructor(
        private translationService: PershingTranslationService,
        private nxiIconService: NxiIconService,
        private authorizationService: IAuthorizationService,
        private location: Location,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
        this.hasMessage = false;
        this.appSettings = appSettings;
        if (appSettings.ibdConfigMap) {
            this.isLoggedIn = appSettings.isLoggedIn;
        }
        let url = this.location.path(false);
        let urlArray = url.split('/');
        if (urlArray[2] === 'disclosure') {
            this.isDisclosurePage = true;
        } else {
            this.isDisclosurePage = false;
        }
        if (appSettings.isCBOL) {
            this.isCBOL = appSettings.isCBOL;
        }
        if (appSettings.isSSOLogoutHide) {
            this.isSSOLogoutHide = appSettings.isSSOLogoutHide;
        }
        if (appSettings.ibdConfigMap.community && appSettings.ibdConfigMap.community === 'equipt') {
            this.hideMessageIcon = true;
        }
        if (appSettings.isModernTheme) {
            this.isModernTheme = true;
        }
    }
    ngOnInit() {
        if (this.isLoggedIn && !this.isPreLogin) {
            this.isTradeEntitled = this.authorizationService.isEntitled(this.tradingEntitlements.join(' || '));
            this.isTransferEntitled = this.authorizationService.isEntitled('ASSET_TRANSFER_MASTER && FUNDS_TRANSFER');
            this.isPayBillsEntitled = this.authorizationService.isEntitled('BILLSUITE');

            let suppressGoPaperless = false;
            if (this.appSettings.ibdConfigMap.suppressGoPaperless !== undefined) {
                suppressGoPaperless = this.appSettings.ibdConfigMap.suppressGoPaperless;
            }
            // For Empower we need to show a dummy span for GoPaperless
            // Even though entitlement is not present for GoPaperless
            // This is because of the complicated navigation structure and styles for Empower
            if ((!this.authorizationService.isEntitled('ELECTRONIC_NOTIFICATION')) && this.goPaperlessFillerSpanIBDList.includes(this.appSettings.ibdConfigMap.IBD)) {
                this.showGoPaperlessFillerSpan = true;
            }
            this.fetchMsgList();
            if (this.authorizationService.isEntitled(this.marketSnapshotEntitlements.join(' || '))) {
                this.isMarketSnapshotsEnabled = true;
            }
            // Certain IBDs need ELECTRONIC_NOTIFICATION enabled
            // but should not be shown with GoPaperless and Edelivery Preferences
            if (this.authorizationService.isEntitled('ELECTRONIC_NOTIFICATION') && (!suppressGoPaperless)) {
                this.isEdelEnabled = true;
            }
        }
    }

    redirectRoute(url: string): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': url
            }
        }));
        this.redirect.emit();
    }

    logout(): void {
        document.dispatchEvent(new CustomEvent('portal.LogoutEvent'));
    }

    fetchMsgList(): any {
        this.nxiIconService.getMessages()
            .subscribe((data: any) => {
                if (data.errorDescription === 'SUCCESS') {
                    this.msgLists = data.response;
                    if (this.msgLists.length === 0 || (this.msgLists.length > 0 && this.haveAllMsgRead())) {
                        this.noMessages = true;
                    }
                    return true;
                } else {
                    return false;
                }
            },
                error => {
                    return false;
                });
        return true;
    }

    haveAllMsgRead() {
        // retrieve from user local memory as this saved from message-center
        let readItems = !!localStorage && !!localStorage.getItem('readMessages') ? localStorage.getItem('readMessages').split(',') : [];
        // Check if every msg in the list has been read (i.e. found in readItems)
        let allRead: boolean = true;
        for (let i = 0; i < this.msgLists.length; i++) {
            if (readItems.indexOf(this.msgLists[i].docId) < 0) {
                allRead = false;
                break;
            }
        }
        return allRead;
    }

    navigateToUrl() {
        let url: string = "";
        NavigationConstants.entitlementsDetails.forEach((item) => {
             if (this.authorizationService.isEntitled(item.entitlements) && url == "") {
             url = item.url;
            }
        })
        this.redirectRoute('/nxi/transact/neworder/' + url);
    }
}
